class EqualHeightModule {
    constructor(selector) {
        this.selector = selector;
        this.equalHeight = document.querySelectorAll(selector);
        this.initEqualHeight();
        this.addResizeListener();
        this.addOrientationChangeListener();
    }

    initEqualHeight() {
        const elements = document.querySelectorAll('[data-equal-height]');
        elements.forEach(element => {
            const section = element.closest('section');
            if (section && section.contains(element)) {
                const selector = element.getAttribute('data-equal-height');
                const sectionElements = section.querySelectorAll(`[data-equal-height="${selector}"]`);
                setTimeout(() => {
                    this.adjustEqualHeight(sectionElements);
                }, 200);
            }
        });
    }

    adjustEqualHeight(elementsArray) {
        elementsArray.forEach(element => {
            element.style.height = 'auto';
            element.style.minHeight = '0';
        });

        let maxHeight = 0;
        elementsArray.forEach(element => {
            const elementHeight = element.offsetHeight;
            maxHeight = Math.max(maxHeight, elementHeight);
        });

        elementsArray.forEach(element => {
            element.style.minHeight = `${maxHeight}px`;
        });
    }

    addResizeListener() {
        window.addEventListener('resize', this.throttle(() => {
            requestAnimationFrame(() => {
                this.initEqualHeight();
            });
        }, 20));
    }

    addOrientationChangeListener() {
        window.addEventListener('orientationchange', this.throttle(() => {
            requestAnimationFrame(() => {
                this.initEqualHeight();
            });
        }, 20));
    }

    throttle(fn, wait) {
        let lastTime = 0;
        return function (...args) {
            const now = new Date().getTime();
            if (now - lastTime >= wait) {
                lastTime = now;
                fn(...args);
            }
        };
    }
}

export default EqualHeightModule;
